import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { AdminComponent } from './admin.component';
import { UsersComponent } from './users.component';
import { CustomersComponent } from './customers.component';
import { CommentComponent } from './comments.component';
import { UserAddComponent } from './user.add.component';
import { CustomerAddComponent } from './customer.add.component';
import { CustomerDetailComponent } from './customer.detail.component';
import { NotificationsComponent } from './notificiations.component';
import { ActivitiesComponent } from './activities.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AdminService } from './admin.service';
import { LaddaModule } from 'angular2-ladda';
import { AdminRoutingModule } from './admin-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgxDropzoneModule } from 'ngx-dropzone';

@NgModule({
    imports: [CommonModule, BrowserModule, FormsModule, ReactiveFormsModule, NgSelectModule, CoreModule,
        NgxPaginationModule,
        NgxDropzoneModule,
        LaddaModule.forRoot({
            style: 'contract',
            spinnerSize: 30,
            spinnerColor: 'white',
            spinnerLines: 12
        }), AdminRoutingModule
    ],
    declarations: [AdminComponent, UsersComponent, UserAddComponent, CustomersComponent, CustomerAddComponent, CustomerDetailComponent,
        NotificationsComponent, CommentComponent, ActivitiesComponent],
    exports: [AdminComponent],
    providers: [AdminService]
})
export class AdminModule { }
